import { useCallback, useEffect } from "react";

interface IUseSaveFormByShortcutParameters {
    saveFormFunction: () => void | Promise<unknown>;
    isFormDirty: boolean;
}

export const useSaveFormByShortcut = (useSaveFormByShortcutParameters: IUseSaveFormByShortcutParameters) => {
    const { saveFormFunction, isFormDirty } = useSaveFormByShortcutParameters;

    const onKeyDown = useCallback(
        (e: KeyboardEvent) => {
            if (e.key?.toLowerCase() === "s" && (e.ctrlKey || e.metaKey)) {
                e.preventDefault();
                if (isFormDirty) {
                    saveFormFunction();
                }
            }
        },
        [saveFormFunction, isFormDirty]
    );

    useEffect(() => {
        document.addEventListener("keydown", onKeyDown);

        return () => {
            document.removeEventListener("keydown", onKeyDown);
        };
    }, [onKeyDown]);
};
